<template>
  <div
    v-if="comboCompany && comboCompany.products.includes(productId)"
    class="order__tag"
    :style="'width: fit-content;padding: 5px 8px;color:white; background:' + comboCompany.product_teg_bg"
    v-html="comboCompany.product_teg"
  ></div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'ComboTag',

  props: {
    productId: {
      type: Number,
      required: true,
    }
  },

  computed:{
    ...mapState({
      comboCompany: (state) => state.cart.comboCompany,
    })
  }
}
</script>